export const INTERFACE_SOUND_VOLUME = 0.3;

export const applyInterfaceSoundVolume = (audio: HTMLAudioElement, volume = INTERFACE_SOUND_VOLUME) => {
    audio.volume = volume;
};

export const createInterfaceSound = (src: string, volume = INTERFACE_SOUND_VOLUME): HTMLAudioElement => {
    const audio = new Audio(src);
    applyInterfaceSoundVolume(audio, volume);

    return audio;
};

export const setInterfaceSoundVolume = (audio: HTMLAudioElement, volume = INTERFACE_SOUND_VOLUME) => {
    applyInterfaceSoundVolume(audio, volume);
};

export const playInterfaceSound = (audio: HTMLAudioElement, volume = INTERFACE_SOUND_VOLUME) => {
    applyInterfaceSoundVolume(audio, volume);

    return audio.play();
};
